import './S_Checkbox.scss';
import { Checkbox } from '@mui/joy';
import classNames from 'classnames';
import { ComponentProps, ReactElement } from 'react';

interface S_CheckboxProps extends ComponentProps<typeof Checkbox> {
  valid?: boolean;
  invalid?: boolean;
}

export const S_Checkbox = ({ title, className, valid, invalid, ...rest }: S_CheckboxProps): ReactElement => (
  <span
    title={title}
    className='s-checkbox-wrapper'
  >
    <Checkbox
      {...rest}
      className={classNames(className, { valid, invalid })}
    />
  </span>
);
